import React, { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { browserSessionPersistence, onAuthStateChanged, setPersistence, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { authSolicitacaoExclusao, functionsSolicitacaoExclusao } from './firebase';

function mensagemDoErro(error) {
  const codigo = String(error?.code || '');

  if (codigo.includes('invalid-credential') || codigo.includes('wrong-password') || codigo.includes('user-not-found')) {
    return 'E-mail ou senha inválidos.';
  }

  return error?.message || 'Não foi possível enviar sua solicitação agora.';
}

function PaginaSolicitacaoExclusaoConta() {
  const [usuario, setUsuario] = useState(authSolicitacaoExclusao.currentUser);
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);
  const [verificandoElegibilidade, setVerificandoElegibilidade] = useState(false);
  const [motivoBloqueio, setMotivoBloqueio] = useState('');

  useEffect(() => onAuthStateChanged(authSolicitacaoExclusao, (user) => {
    setUsuario(user || null);
    setErro('');
    setMotivoBloqueio('');
    setSucesso(false);
  }), []);

  useEffect(() => {
    if (!usuario) {
      setVerificandoElegibilidade(false);
      return undefined;
    }

    let ativo = true;
    setVerificandoElegibilidade(true);
    setMotivoBloqueio('');

    async function verificarElegibilidade() {
      try {
        const consultarElegibilidade = httpsCallable(functionsSolicitacaoExclusao, 'consultarElegibilidadeExclusaoConta');
        const resposta = await consultarElegibilidade();
        if (ativo && resposta.data?.elegivel === false) {
          setMotivoBloqueio(resposta.data?.motivo || 'Esta conta não pode solicitar exclusão agora.');
        }
      } catch (error) {
        if (ativo) {
          setErro(mensagemDoErro(error));
        }
      } finally {
        if (ativo) {
          setVerificandoElegibilidade(false);
        }
      }
    }

    verificarElegibilidade();
    return () => {
      ativo = false;
    };
  }, [usuario?.uid]);

  async function entrar(event) {
    event.preventDefault();
    setErro('');
    setCarregando(true);

    try {
      await setPersistence(authSolicitacaoExclusao, browserSessionPersistence);
      await signInWithEmailAndPassword(authSolicitacaoExclusao, email.trim(), senha);
      setSenha('');
    } catch (error) {
      setErro(mensagemDoErro(error));
    } finally {
      setCarregando(false);
    }
  }

  async function enviarSolicitacao(event) {
    event.preventDefault();
    setErro('');

    setCarregando(true);
    try {
      const solicitarExclusao = httpsCallable(functionsSolicitacaoExclusao, 'solicitarExclusaoConta');
      await solicitarExclusao({});
      setSucesso(true);
    } catch (error) {
      setErro(mensagemDoErro(error));
    } finally {
      setCarregando(false);
    }
  }

  async function sair() {
    await signOut(authSolicitacaoExclusao);
    setSucesso(false);
  }

  return (
    <main className="privacy-page">
      <section className="privacy-page__card deletion-request" aria-labelledby="deletion-title">
        <div className="privacy-page__brand">
          <img src="/promoalert-panel-brand-dark.png" alt="PromoAlert" />
        </div>

        <div className="privacy-page__heading">
          <h1 id="deletion-title">Solicitar exclusão de conta</h1>
          <span>Para solicitar exclusão de conta, efetue abaixo o login com o mesmo usuário do app PromoAlert.</span>
        </div>

        {!usuario ? (
          <form className="deletion-request__form" onSubmit={entrar}>
            <label className="deletion-request__sr-only" htmlFor="delete-email">E-mail</label>
            <input
              id="delete-email"
              type="email"
              autoComplete="email"
              placeholder="E-mail"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              disabled={carregando}
            />
            <label className="deletion-request__sr-only" htmlFor="delete-password">Senha</label>
            <input
              id="delete-password"
              type="password"
              autoComplete="current-password"
              placeholder="Senha"
              value={senha}
              onChange={(event) => setSenha(event.target.value)}
              required
              disabled={carregando}
            />
            {erro && <p className="deletion-request__error" role="alert">{erro}</p>}
            <button type="submit" disabled={carregando}>{carregando ? 'Validando acesso...' : 'Entrar'}</button>
          </form>
        ) : verificandoElegibilidade ? (
          <div className="deletion-request__checking" role="status">Validando sua conta...</div>
        ) : motivoBloqueio ? (
          <div className="deletion-request__blocked" role="alert">
            <p>{motivoBloqueio}</p>
            <button type="button" onClick={sair}>Usar outra conta</button>
          </div>
        ) : sucesso ? (
          <div className="deletion-request__success" role="status">
            <h2>Solicitação recebida</h2>
            <button type="button" onClick={sair}>Sair da conta</button>
          </div>
        ) : (
          <form className="deletion-request__form" onSubmit={enviarSolicitacao}>
            {erro && <p className="deletion-request__error" role="alert">{erro}</p>}
            <button type="submit" disabled={carregando}>{carregando ? 'Enviando solicitação...' : 'Enviar solicitação de exclusão'}</button>
          </form>
        )}

        <div className="privacy-page__footer">
          <a href="/">Voltar ao painel</a>
        </div>
      </section>
    </main>
  );
}

export default PaginaSolicitacaoExclusaoConta;
